// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1A8qh","select":"Header_select__3QVEQ","clinic":"Header_clinic__FGYQX"};